import { createFileRoute } from '@tanstack/react-router'
import ContatoImportarPage from '@/pages/contatos/contato-importar'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Rota para importar contatos via arquivo CSV/XLS/VCF
// Path completo será /dashboard/$dashboardId/contatos/importar
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/contatos/importar',
)({
  component: function ContatoImportarRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.CONTATOS} dashboardId={dashboardId}>
        <ContatoImportarPage dashboardId={dashboardId} />
      </RequireModule>
    )
  },
})
